import { ViteReactSSG } from 'vite-react-ssg';

import { routes } from './routes/routes';
import './index.css';

// vite-react-ssg owns mounting/hydration: in dev (`vite-react-ssg dev`) it
// renders client-side; at build (`vite-react-ssg build`) it walks `routes`,
// pre-renders each concrete path to its own HTML file, then hydrates on the
// client. Providers/router live in the route tree (RootLayout), so there's no
// manual createRoot(...).render() here anymore.
export const createRoot = ViteReactSSG({ routes });
